export function getContrastColor(color: string): 'light' | 'dark' {
  const hex = String(color.replace(/^#/, '') || '');

  const r = Number.parseInt(hex.substring(0, 2), 16);
  const g = Number.parseInt(hex.substring(2, 4), 16);
  const b = Number.parseInt(hex.substring(4, 6), 16);

  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

  return luminance > 0.5 ? 'dark' : 'light';
}
